export default "__VITE_ASSET__Co9kU4kQ__"